export default {
  myExam_score_total_score: 'Exam grade {score}/{totalScore}',
  myExam_no_chance: 'Exam chances have been used up',
  myExam_still: 'You have {remainNum} chances to take the exam',
  myExam_exam_ended: 'The exam is over',
  myExam_test_num: '{testNum, plural, =0 {no questions} =1 {one question} other {# questions}} in total',
  myExam_current_tab: 'No{currentTab} yet'
}
